import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Preloader } from "@/components/Preloader";
import { Hero } from "@/components/Hero";
import { Introduction } from "@/components/Introduction";
import { CoreExpertise } from "@/components/CoreExpertise";
import { SportsAdvisory } from "@/components/SportsAdvisory";
import { OurClients } from "@/components/OurClients";
import { GeographicReach } from "@/components/GeographicReach";
import { ManifestoSection } from "@/components/ManifestoSection";
import { InvestmentsApproach } from "@/components/InvestmentsApproach";
import { Reveal } from "@/components/Reveal";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main className="bg-[#F6F4F0] text-[#1F1E1B] antialiased">
      <Preloader done={ready} />
      <Navbar />
      <Hero active={ready} />
      <Introduction />
      <CoreExpertise />
      <SportsAdvisory />
      <OurClients />
      <GeographicReach />
      <ManifestoSection />
      <InvestmentsApproach />

      <section data-testid="closing-cta" className="py-28 lg:py-44 border-t border-[#E3E0D8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08] max-w-4xl mx-auto">
              Significant decisions deserve <span className="italic">considered advice.</span>
            </h2>
            <Link
              to="/contact"
              data-testid="closing-cta-contact-link"
              className="group mt-12 inline-flex items-center gap-3 font-sans text-[11px] font-semibold uppercase tracking-[0.24em] text-[#1F1E1B]"
            >
              <span className="relative">
                Contact PJG Capital Partners
                <span className="absolute -bottom-1.5 left-0 h-px w-full bg-[#1F1E1B]/25" />
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[#1F1E1B] transition-[width] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:w-full" />
              </span>
              <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </section>

      <Footer />
    </main>
  );
}
